import { useTranslation } from 'react-i18next'

export const VoterRegFooterContent = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'voterRegistrationForm',
  })
  return <div dangerouslySetInnerHTML={{ __html: t('footerContent') }}></div>
}
